import React from 'react';
import { motion } from 'motion/react';
import { ChevronUp, ChevronDown } from 'lucide-react';

const SubscriptionTableHeader = ({ column, sortConfig, onSort }) => {
  const isSorted = sortConfig.key === column.key;
  const isAscending = sortConfig.direction === 'asc';

  const handleSort = () => {
    if (column.sortable) {
      onSort(column.key);
    }
  };

  const getColumnClass = () => {
    const baseClass = "flex items-center gap-2 text-sm font-semibold text-gray-700";
    const sortableClass = column.sortable ? "cursor-pointer hover:text-gray-900" : "";
    return `${baseClass} ${sortableClass}`;
  };

  const getSortIcon = () => {
    if (!column.sortable) return null;
    
    if (isSorted) {
      return isAscending ? (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 500, damping: 30 }}
        >
          <ChevronUp className="w-4 h-4 text-purple-600" />
        </motion.div>
      ) : (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 500, damping: 30 }}
        >
          <ChevronDown className="w-4 h-4 text-purple-600" />
        </motion.div>
      );
    }
    
    return (
      <div className="flex flex-col">
        <ChevronUp className="w-3 h-3 text-gray-400" />
        <ChevronDown className="-mt-1 w-3 h-3 text-gray-400" />
      </div>
    );
  };

  return (
    <div className="min-w-0">
      <motion.div
        whileHover={column.sortable ? { scale: 1.02 } : {}}
        whileTap={column.sortable ? { scale: 0.98 } : {}}
        onClick={handleSort}
        className={getColumnClass()}
      >
        <span className="truncate">{column.label}</span>
        {getSortIcon()}
      </motion.div>
    </div>
  );
};

export default SubscriptionTableHeader;